export const HELP_SECTIONS = [

  {
    section: 'Overview',
    items: [
      'how-everyid-works',
      'projects',

    ]
  },

  {
    section: 'Design Tools',
    items: [
      'landing-pages',
      'actions',
      'card-designs',
      'media-library',
      'project-templates'
    ]
  },

  {
    section: 'Operations',
    items: [
      'data-records',
      'printers',
      'printer-groups'
    ]
  },

  {
    section: 'Applications',
    items: [
      'live-gallery',
      'results-portal',
      'games'
    ]
  }

];

export const HELP_ARTICLES = {

  'how-everyid-works': {
    title: 'How {{brandName}} Works',
    category: 'Getting Started',
    file: 'how-everyid-works.html',
    related: [
      'project-templates',
      'projects',
      'landing-pages'
    ]
  },

  'project-templates': {
    title: 'Project Templates',
    category: 'Core Concepts',
    file: 'project-templates.html',
    related: [
      'projects',
      'landing-pages',
      'how-everyid-works'
    ]
  },

  'projects': {
    title: 'Projects',
    category: 'Core Concepts',
    file: 'projects.html',
    related: [
      'project-templates',
      'data-records',
      'actions'
    ]
  },

  'data-records': {
    title: 'Data Records',
    category: 'Core Concepts',
    file: 'data-records.html',
    related: [
      'projects',
      'card-designs',
      'actions'
    ]
  },

  'landing-pages': {
    title: 'Landing Pages',
    category: 'Core Concepts',
    file: 'landing-pages.html',
    related: [
      'actions',
      'projects',
      'card-designs'
    ]
  },

  'actions': {
    title: 'Actions',
    category: 'Core Concepts',
    file: 'actions.html',
    related: [
      'landing-pages',
      'data-records',
      'card-designs'
    ]
  },

  'card-designs': {
    title: 'Card Designs',
    category: 'Core Concepts',
    file: 'card-designs.html',
    related: [
      'data-records',
      'actions',
      'projects'
    ]
  },

  'media-library': {
    title: 'Media Library',
    category: 'Design Tools',
    file: 'media-library.html',
    related: [
      'landing-pages',
      'card-designs',
      'projects'
    ]
  },

  'printers': {
    title: 'Printers',
    category: 'Operations',
    file: 'printers.html',
    related: [
      'printer-groups',
      'actions',
      'card-designs'
    ]
  },

  'printer-groups': {
    title: 'Printer Groups',
    category: 'Operations',
    file: 'printer-groups.html',
    related: [
      'printers',
      'actions'
    ]
  },

  'live-gallery': {
    title: 'Live Gallery',
    category: 'Applications',
    file: 'live-gallery.html',
    related: [
      'results-portal',
      'games'
    ]
  },

  'results-portal': {
    title: 'Results Portal',
    category: 'Applications',
    file: 'results-portal.html',
    related: [
      'live-gallery',
      'games'
    ]
  },

  'games': {
    title: 'Games',
    category: 'Applications',
    file: 'games.html',
    related: [
      'results-portal',
      'live-gallery'
    ]
  }

};
